export interface HistoryItem {
  id: string
  tool: string
  toolName: string
  input: string
  output: string
  timestamp: number
}

const HISTORY_KEY = 'toolHistory'
const MAX_HISTORY_ITEMS = 100

export const addToHistory = (item: Omit<HistoryItem, 'id' | 'timestamp'>): void => {
  const history = getHistory()
  
  const newItem: HistoryItem = {
    ...item,
    id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
    timestamp: Date.now(),
  }
  
  // Add to beginning of array
  history.unshift(newItem)
  
  // Keep only the last MAX_HISTORY_ITEMS
  if (history.length > MAX_HISTORY_ITEMS) {
    history.splice(MAX_HISTORY_ITEMS)
  }
  
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history))
}

export const getHistory = (): HistoryItem[] => {
  try {
    const stored = localStorage.getItem(HISTORY_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (error) {
    console.error('Error reading history:', error)
  }
  return []
}

export const clearHistory = (): void => {
  localStorage.removeItem(HISTORY_KEY)
}

export const removeHistoryItem = (id: string): void => {
  const history = getHistory()
  const filtered = history.filter(item => item.id !== id)
  localStorage.setItem(HISTORY_KEY, JSON.stringify(filtered))
}
